module.exports = __webpack_public_path__ + "img/favoritos.19bfe427.png";